export class QueryKey {
  public static readonly TODOS = 'todos';
  public static readonly TODO = 'todo';
  public static readonly TODO_STATUSES = 'todoStatuses';
  public static readonly TODO_STATUS_SUMMARIES = 'todoStatusSummaries';
  public static readonly DASHBOARD_PRODUCT_HISTORY = 'dashboard-product-history';
  public static readonly DASHBOARD_TODO_STATS = 'dashboard-todo-stats';
  public static readonly DASHBOARD_TIMESHEET_STATS = 'dashboard-timesheet-stats';
  public static readonly DASHBOARD_INVOICING_STATS = 'dashboard-invoicing-stats';
  public static readonly CURRENT_USER = 'currentUser';
  public static readonly TAXES = 'taxes';
  public static readonly TAX = 'tax';
  public static readonly LEGAL_ENTITIES = 'legalEntities';
  public static readonly INVOICES = 'invoices';
  public static readonly COMPANY = 'company';
  public static readonly CONTACT = 'contact';
  public static readonly COUNTRY_DETAILS = 'countryDetails';
  public static readonly USERS = 'USERS';
  public static readonly FOLDERS = 'folders';
  public static readonly DOCUMENTS = 'documents';
  public static readonly TIMESHEETS = 'timesheets';
  public static readonly TIMESHEET = 'timesheet';
  public static readonly TIMESHEET_DOCUMENTS = 'timesheetDocuments';
  public static readonly CALL_STATISTICS = 'callStatistics';
  public static readonly CALL_STATISTICS_LIVE = 'callStatisticsLive';
  public static INCOMING_INVOICES = 'incoming-invoices';
  public static OUTGOING_INVOICES = 'outgoing-invoices';
  public static CREDIT_NOTES = 'credit-notes';
  public static INCOMING_CREDIT_NOTES = 'incoming-credit-notes';
  public static OUTGOING_CREDIT_NOTES = 'outgoing-credit-notes';
  public static readonly TIMESHEET_TYPES = 'timesheetTypes';
  public static readonly TIMESHEET_TYPES_SELECT = 'timesheetTypesSelect';
  public static readonly ACTIVITY_TYPES = 'activityTypes';
  public static readonly ACTIVITY_TYPES_SELECT = 'activityTypesSelect';
  public static readonly TIMESHEET_STATUSES = 'timesheetStatuses';
  public static readonly TIMESHEET_STATUSES_SELECT = 'timesheetStatusesSelect';
  public static readonly PRODUCTS = 'products';
  public static readonly PRODUCT = 'product';
  public static readonly PRODUCT_SELECT = 'productSelect';
  public static readonly PRODUCT_DETAILS = 'productDetails';
  public static readonly ACCOUNTING_ACCOUNTS = 'accountingAccounts';
  public static readonly ACCOUNTING_ACCOUNT = 'accountingAccountH';
  public static readonly ACCOUNTING_PERIODS = 'accountingPeriods';
  public static readonly TAXES_SELECT = 'taxesSelect';
  public static readonly UNIT_OF_MEASURE_SELECT = 'unitOfMeasureSelect';
  public static readonly MAIL_TEMPLATES = 'mailTemplates';
  public static readonly MAIL_TEMPLATE = 'mailTemplate';
  public static readonly PRODUCT_CUSTOMERS = 'productCustomers';
  public static readonly PRODUCT_CUSTOMER_BILLINGS = 'productCustomerBillings';
  public static readonly PRODUCT_CUSTOMER_HISTORY = 'productCustomerHistory';
  public static readonly INVOICING_PREVIEW = 'invoicingPreview';
  public static readonly LICENCE_SERVERS = 'licenceServers';
  public static readonly LICENCE_PLAN_SELECT = 'licencePlanSelect';
  public static readonly LICENCE_PLANS = 'licencePlans';
  public static readonly LICENCE_PLAN = 'licencePlan';
  public static readonly FEATURE_SELECT = 'featureSelect';
  public static readonly FEATURES = 'features';
  public static readonly FEATURE = 'feature';
  public static readonly PLUGIN_SELECT = 'pluginSelect';
  public static readonly PLUGINS = 'plugins';
  public static readonly PLUGIN = 'plugin';
  public static readonly PAYMENT_MODES = 'paymentModes';
  public static readonly PERMISSIONS = 'permissions';
  public static readonly PERMISSION_CATALOG = 'permissionCatalog';
  public static readonly CUSTOMER_ANALYSIS = 'customerAnalysis';
}
